import React from "react"
import styled from 'styled-components'
import Layout from "../components/Layout"
import ContentWidth from "../components/ContentWidth"
import media from "../styles/media"

const ErrorPage = () => {
  return (
    <Layout>
    <ContentWidth>
      <Heading>NOT FOUND</Heading>
      <BodyText>You just hit a route that doesn&#39;t exist.</BodyText>
    </ContentWidth>
  </Layout>
  )
}

const Heading = styled.h1`
    font-family: Archivo;
    font-size: 4.167vw;
    line-height: 4.444vw;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: center;
    margin: 2.778vw auto;

  ${media.fullWidth}{
    font-size: 60px;
    line-height: 64px;
    margin: 40px auto;
  }
  ${media.tablet}{
    font-size: 60px;
    line-height: 64px;
    margin: 3.906vw auto;
  }
  ${media.mobile}{
    font-size: 48px;
    line-height: 56px;
    margin: 5.333vw auto;
  }
`
const BodyText = styled.p`
    font-family: Archivo;
    font-weight: 400;
    font-size: 1.667vw;
    line-height: 2.5vw;
    letter-spacing: 0em;
    text-align: center;

  ${media.fullWidth}{
    font-size: 24px;
    line-height: 36px;
  }
  ${media.tablet}{
    font-size: 2.344vw;
    line-height: 3.516vw;
  }
  ${media.mobile}{
    font-size: 4.8vw;
    line-height: 7.2vw;
  }
`
export default ErrorPage;